module.exports = __webpack_public_path__ + "static/img/top-base.cd62cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/top-base.png
// module id = o66y
// module chunks = 0